var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            border: "",
            "header-cell-style": {
              backgroundColor: "#FDEFE7",
              color: "#000000",
            },
            data: _vm.tableData,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "left",
              align: "center",
              prop: "orderMainId",
              label: "发票订单号",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return _vm._l(scope.row.orderIds, function (item, index) {
                    return _c("p", { key: index }, [
                      _vm._v(" " + _vm._s(item) + " "),
                    ])
                  })
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "name",
              label: "发票订单生成时间",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("dateFormatHms")(scope.row.createTime)) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "address",
              label: "增值税专票费用",
              width: "180",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "name",
              label: "支付方交易单号",
              width: "180",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "address",
              label: "订单状态",
              width: "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.invoiceType[scope.row.status]) + " "
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm.tableData.length > 0
        ? _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                border: "",
                "header-cell-style": {
                  backgroundColor: "#FDEFE7",
                  color: "#000000",
                },
                data: _vm.tableData[0].invoicingDetailList,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  fixed: "left",
                  align: "center",
                  prop: "date",
                  label: "发票类型",
                  width: "180",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " + _vm._s(_vm.invoiceType1[scope.row.type]) + " "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3572578299
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "lookUp",
                  label: "发票抬头",
                  width: "270",
                },
              }),
              _c(
                "el-table-column",
                {
                  attrs: {
                    align: "center",
                    prop: "address",
                    label: "发票内容",
                    width: "180",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.tableData[0].invoicingContent) + " ")]
              ),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "name",
                  label: "收票人信息",
                  width: "270",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }